import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var HostLicenseService = /** @class */ (function (_super) {
    tslib_1.__extends(HostLicenseService, _super);
    function HostLicenseService(http) {
        var _this = _super.call(this, http, MapperService.hostLicenseMap) || this;
        _this._endpoint = '/odata/HostLicenses';
        return _this;
    }
    HostLicenseService.prototype.getLicenseForTenant = function (tenantId) {
        var _this = this;
        var tenantLicenseEndpoint = this._endpoint + "/UiPath.Server.Configuration.OData.GetTenantLicense(tenantId=" + tenantId + ")";
        return this._http
            .get(tenantLicenseEndpoint)
            .pipe(map(function (response) { return _this._mapData(response); }));
    };
    HostLicenseService.prototype.setLicenseForTenant = function (licenseConfiguration) {
        var setTenantLicenseEndpoint = this._endpoint + "/UiPath.Server.Configuration.OData.SetTenantLicense";
        var mapperDefinition = MapperService.tenantLicenseMap;
        var payload = {
            license: this._toPoco(licenseConfiguration, mapperDefinition),
        };
        return this._http
            .post(setTenantLicenseEndpoint, payload);
    };
    HostLicenseService.prototype.deleteLicenseForTenant = function (tenantId) {
        var deleteTenantLicenseEndpoint = this._endpoint + "/UiPath.Server.Configuration.OData.DeleteTenantLicense";
        var payload = JSON.stringify({
            tenantId: tenantId,
        });
        return this._http
            .post(deleteTenantLicenseEndpoint, payload);
    };
    return HostLicenseService;
}(ODataService));
export { HostLicenseService };
